export default __webpack_public_path__ + "static/media/tech-blog.d2d72192.gif";